import { testActions } from "../_constants/actionConstants";

const testInitState = {
  data: null,
  fetching: false
};

export const reducer = (state = testInitState, action) => {
  switch (action.type) {
    case testActions.TEST_REQ:
    case testActions.TEST_REQ_REJECTED:
      return { ...state, fetching: true };
    case testActions.TEST_REQ_FULFILLED:
      return { ...state, data: action.payload, fetching: false };
    default:
      return state;
  }
};
